import { useEffect, useState } from "react";
import { createRecipient, listRecipients, type Recipient } from "../api";
import type { T } from "../i18n";

export function Recipients({ t }: { t: T }) {
  const [items, setItems] = useState<Recipient[]>([]);
  const [name, setName] = useState("");
  const [kind, setKind] = useState("person");
  const [error, setError] = useState<string | null>(null);

  const load = () => listRecipients().then((r) => setItems(r.recipients)).catch(() => setError(t("common.error")));
  useEffect(() => {
    void load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function add() {
    setError(null);
    try {
      await createRecipient(kind, name);
      setName("");
      await load();
    } catch {
      setError(t("common.error"));
    }
  }

  return (
    <div>
      <div className="form-row">
        <select value={kind} onChange={(e) => setKind(e.target.value)}>
          <option value="person">person</option>
          <option value="team">team</option>
          <option value="service">service</option>
          <option value="pool">pool</option>
        </select>
        <input placeholder={t("recipients.name")} value={name} onChange={(e) => setName(e.target.value)} />
        <button onClick={add} disabled={!name}>
          {t("recipients.add")}
        </button>
      </div>
      {error && <p className="error">{error}</p>}
      <table>
        <thead>
          <tr>
            <th>{t("recipients.name")}</th>
            <th>{t("recipients.kind")}</th>
            <th>{t("recipients.id")}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.id}>
              <td>{r.display_name}</td>
              <td>{r.kind}</td>
              <td className="mono">{r.id}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
